import { all, fork } from 'redux-saga/effects'
import loginWatcherSaga from '../Login/Saga'
import signupWatcherSaga from '../Signup/Saga'
import pesticideWatcherSaga from '../AllPesticide/Saga'
import categoryWatcherSaga from '../AllCategory/Saga'
import multiplePesticideWatcherSaga from '../MultiplePesticide/Saga'
import orderWatcherSaga from '../Order/Saga'
import getPesticideByWatcherSaga from '../PesticideBy/Saga'

export default function* rootSaga() {
  yield all([
    fork(loginWatcherSaga),
    fork(signupWatcherSaga),
    fork(pesticideWatcherSaga),
    fork(categoryWatcherSaga),
    fork(multiplePesticideWatcherSaga),
    fork(orderWatcherSaga),
    fork(getPesticideByWatcherSaga),
  ])
}
